import React, { FC, useMemo } from "react";
import { MediumHeader } from "@narvar/nth-bit-header";
import { ReturnReasonsTypeProps } from "./types";
import LanguageKeys from "../../ReviewSummary/consts/language_en_US";
import { ReturnReasonsReturnType } from "../types";
import { useLanguage } from "@narvar/nth-kit-returns-headless";
import { SelectListOption } from "../../ReviewSummary/components/SelectList/types";
import { Language } from "../../ReviewSummary/components";
import SelectList from "../../ReviewSummary/components/SelectList/SelectList";

const tempLanguageKeys = {
  returnsReasonsTypeTitle: LanguageKeys.returnsReasonsTypeTitle,
  returnsReasonsTypeReturn: LanguageKeys.returnsReasonsTypeReturn,
  returnsReasonsTypeExchange: LanguageKeys.returnsReasonsTypeExchange,
};

const ReturnReasonsType: FC<ReturnReasonsTypeProps> = ({
  allowReturn,
  allowExchange,
  allowClaim,
  claimIneligibleReason,
  onChange,
}) => {
  const {
    returnsReasonsTypeTitle,
    returnsReasonsTypeReturn,
    returnsReasonsTypeExchange,
  } = tempLanguageKeys;

  const returnLabel =
    useLanguage({
      langKey: "returnsReasonsTypeReturn",
      defaultString: returnsReasonsTypeReturn,
    }).rawValue ?? "";
  const exchangeLabel =
    useLanguage({
      langKey: "returnsReasonsTypeExchange",
      defaultString: returnsReasonsTypeExchange,
    }).rawValue ?? "";
  const claimLabel =
    useLanguage({
      langKey: "returnsReasonsTypeClaim",
    }).rawValue ?? "";

  const options: SelectListOption[] = useMemo(() => {
    const ret = [];
    if (allowReturn) {
      ret.push({
        label: returnLabel,
        value: "return",
      });
    }
    if (allowExchange) {
      ret.push({
        label: exchangeLabel,
        value: "exchange",
      });
    }
    if (allowClaim) {
      const label = claimIneligibleReason
        ? `<div style="margin-bottom: 4px;">${claimLabel}</div>
           <div>${claimIneligibleReason}</div>`
        : claimLabel;

      ret.push({
        label,
        value: "claim",
        disabled: !!claimIneligibleReason,
      });
    }
    return ret;
  }, [
    allowReturn,
    allowExchange,
    allowClaim,
    claimIneligibleReason,
    returnLabel,
    exchangeLabel,
    claimLabel,
  ]);

  const handleChange = (e: string) => {
    onChange(e as ReturnReasonsReturnType);
  };

  return (
    <>
      <MediumHeader>
        <Language
          langKey="returnsReasonsTypeTitle"
          defaultString={returnsReasonsTypeTitle}
        />
      </MediumHeader>
      <SelectList onChange={handleChange} options={options} />
    </>
  );
};

export default ReturnReasonsType;
